import React from "react";
import { createUseStyles } from "react-jss";

import { DialogType, useDialog } from "../context/DialogProvider";
import { MelaDialog, MelaDialogContent, Sizes, Text, View } from ".";

const useStyles = createUseStyles({
  actionsContainer: {
    padding: "1rem !important",
    justifyContent: "center !important",
    gap: "0.75rem",
  },
  topMessage: {
    marginTop: "1rem",
  },
});

const CustomDialog = () => {
  const dialog = useDialog();
  const styles = useStyles();

  const onCloseDialog = () => {
    if (dialog.options?.onCancel) {
      dialog.options.onCancel();
    }
    dialog.clear();
  };

  const onConfirmDialog = () => {
    if (dialog.options?.onConfirm) {
      dialog.options.onConfirm();
    }
    dialog.clear();
  };

  if (dialog.status !== DialogType.NONE) {
    return (
      <MelaDialog
        open
        onClose={onCloseDialog}
        onSave={dialog.options?.confirmButton ? onConfirmDialog : undefined}
        onSaveLabel={dialog.options?.confirmText || "button.close.translation"}
        onCloseLabel={dialog.options?.cancelText || "button.close.translation"}
        saveHidden={!dialog.options?.confirmButton}
        title={dialog.dialogTitle}
        footerContainerClassName={styles.actionsContainer}
      >
        <MelaDialogContent>
          <View
            dataTestId={dialog.status.toString()}
            style={{ padding: "1rem 0" }}
          >
            <Text size={Sizes.medium}>{dialog.dialogMessage}</Text>
            {dialog.dialogMessage2 && (
              <Text className={styles.topMessage} size={Sizes.medium}>
                {dialog.dialogMessage2}
              </Text>
            )}
          </View>
        </MelaDialogContent>
      </MelaDialog>
    );
  }
  return null;
};

export default CustomDialog;
